import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { NewButton, SaveButton } from "../../../components/Buttons";

export const Departments = () => {
    document.title = "Şöbələr";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ayarlar", value: "/settings" },
        { name: "Şöbələr", value: "/settings/departments", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Şöbələr</h2>
                    <p>
                        İşçiləri və Məhsulları şöbələrə bölmək və işçiləri ( istifadəçiləri ) aidiyyəti üzrə şöbələrə təyin etmək üçün nəzərdə tutulub.
                        Şöbələrdəki əməkdaşların eyni şöbənin məhsulları ilə hərəkətlərini nəzarətdə saxlamağa imkan yaradır.
                        <br />
                        Ayarlar səhifəsində <mark>şöbələr</mark> seçimi edildikdən sonra açılan pəncərədə <NewButton>Şöbə</NewButton> düyməsi ilə yaradılacaq
                        şöbənin adını təyin edib <SaveButton /> düyməsini sıxmaq lazımdır.
                        <br />
                        Nümunədə yeni şöbə yaratmaq ardıcıllığı göstərilib.
                    </p>
                    <img src="/images/settings/departments.gif" alt="Şöbələr" />
                </article>
            </div>
        </div>
    );
};
